<nz-card nzHoverable
         [nzBordered]="true"
         (click)="onCardClick()"
         [class]="'card-container ' + customCardContainerCssClass + '-container'"
         [ngClass]="compactCard ? 'compact-card-container' : ''"
         [ngStyle]="color ? {
           '--card-text-color': color.color,
           '--card-background-color': color.backgroundColor,
           'background-color': color.backgroundColor,
           'color': color.color
         } : {}">
  <div [class]="'card-content ' + customCardContainerCssClass"
       [ngClass]="compactCard ? 'compact-card-content' : ''">
    <div class="card-title-container">
      <i *ngIf="iconName" class="{{iconName}}"
         [ngStyle]="color ? { color: color.color } : {}"></i>
      <rappider-checkbox *ngIf="isCheckable"
                         [(ngModel)]="isCheck"
                         (valueChange)="onCheckboxValueChange($event)"></rappider-checkbox>
      <ng-container *ngIf="compactCard">
        <h6 nz-typography
            class="card-title"
            [ngStyle]="color ? { color: color.color } : {}">{{ title }}</h6>
      </ng-container>
      <ng-container *ngIf="!compactCard">
        <h3 nz-typography
            class="card-title"
            [ngStyle]="color ? { color: color.color } : {}">{{ title }}</h3>
      </ng-container>
    </div>
    <ng-container *ngIf="tags?.length">
      <div class="card-tags-container">
        <nz-tag *ngFor="let tag of tags"
                class="card-tag"
                [nzColor]="tag.color ?? ''"><i class="{{ tag.iconName }}"></i>&nbsp;{{ tag.text }}</nz-tag>
      </div>
    </ng-container>
    <p *ngIf="description"
       nz-typography
       nzType="secondary"
       class="card-description"
       nz-tooltip
       nzTooltipTitle="{{ description }}"
       [ngStyle]="color ? { color: color.color } : {}">
      {{ description }}
    </p>
    <ng-container *ngTemplateOutlet="customTemplate; context: { $implicit: templateData }"></ng-container>
  </div>
</nz-card>
